import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { useDomainContext } from "@hooks/useDomainContext";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import ClearYourDebtsFastWrapper from "@components/layouts/clearYourDebtsFastWrapper";

export default function PrivacyPolicyHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <ClearYourDebtsFastWrapper>
            <PrivacyPolicy
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </ClearYourDebtsFastWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
